// Generated by purs version 0.14.4
var semigroupoidFn = {
    compose: function (f) {
        return function (g) {
            return function (x) {
                return f(g(x));
            };
        };
    }
};
var compose = function (dict) {
    return dict.compose;
};
var composeFlipped = function (dictSemigroupoid) {
    return function (f) {
        return function (g) {
            return compose(dictSemigroupoid)(g)(f);
        };
    };
};
export {
    compose,
    composeFlipped,
    semigroupoidFn
};
//# sourceMappingURL=index.js.map
